<template>
  <el-form ref="form_tw" :model="form_tw" label-width="0px" @submit.native.prevent>
    <div class="side-search-form-box">
      <div class="side-search-form-title">ユーザー名/キーワード検索</div>
      <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
        <div class="side-search-form-radio" v-show="activate > 10">
          <el-radio :class="dark_mode ? 'dark' : ''" v-model="form_tw.radio" :label="1" @change="resetKeyword()">
            ユーザー名
          </el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" v-model="form_tw.radio" :label="2" @change="resetKeyword()">
            キーワード
            <el-tooltip placement="top" content="名前、プロフィール、投稿内容に含まれるキーワードで検索します。">
              <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px"/>
            </el-tooltip>
          </el-radio>
        </div>
        <div class="side-search-form-radio" v-show="activate < 10">
          <el-radio :class="dark_mode ? 'dark' : ''" v-model="form_tw.radio" :label="1">ユーザー名</el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" v-model="form_tw.radio" :label="2" disabled>キーワード</el-radio>
        </div>
        <sidemenuSuggestInfluencer 
          v-show="form_tw.radio == 1" 
          :name.sync="form_tw.account_name" 
          :sns_type="'twitter'"
          @resultCount="resultCount()" 
          @nameSearch="nameSearch()"
        />
        <sidemenuSuggestKeyword 
          v-show="form_tw.radio == 2" 
          :keyword.sync="form_tw.keyword" 
          :sns_type="'twitter'" 
          :exclude_keyword.sync="form_tw.exclude_keyword"
          @resultCount="resultCount()" 
          @search="search()"
        />
      </div>
    </div>

    <div class="side-search-form-box">
      <div class="side-search-form-title">他SNS登録</div>
      <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
        <el-radio-group v-model="form_tw.other_sns_type" size="mini" style="margin: 12px 0 0;" @change="resultCount()">
          <el-radio :class="dark_mode ? 'dark' : ''" label="">
            -
          </el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" label="instagram">
            <font-awesome-icon :icon="['fab', 'instagram']" style="margin-left:4px; font-size:16px"/>
          </el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" label="youtube">
            <font-awesome-icon :icon="['fab', 'youtube']" style="margin-left:4px; font-size:16px"/>
          </el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" label="tiktok">
            <font-awesome-icon :icon="['fab', 'tiktok']" style="margin-left:4px; font-size:16px"/>
          </el-radio>
        </el-radio-group>
      </div>
    </div>

    <div>
      <div class="side-search-form-box">
        <div class="side-search-form-title">性別</div>
        <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
          <div class="side-search-form-radio" style="margin-bottom:0px">
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form_tw.gender_female" @change="resultCount()">女性
            </el-checkbox>
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form_tw.gender_male" @change="resultCount()">男性
            </el-checkbox>
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form_tw.gender_other" @change="resultCount()">
              その他
              <el-tooltip placement="top"
                          content="その他：ブランド、ショップ、キャラクター/ペットなどの非人物アカウントです">
                <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px"/>
              </el-tooltip>
            </el-checkbox>
            <el-checkbox :class="dark_mode ? 'dark' : ''" v-if="activate == 20 && admin_mode"
                         v-model="form_tw.gender_null" @change="resultCount()" class="bottom"></el-checkbox>
          </div>
        </div>
      </div>
      <div class="side-search-form-title">フォロワー数</div>
      <el-form-item label class="slider">
        <el-slider :class="dark_mode ? 'dark' : ''" v-model="form_tw.followers" @change="resultCount()" :step="5000"
                   name="follower" :marks="follower_marks" range :max="500000"></el-slider>
      </el-form-item>
      <div class="side-search-form-title">EGR</div>
      <el-form-item label class="slider">
        <el-slider
            :class="dark_mode ? 'dark' : ''"
            v-model="form_tw.average_engagement_rate"
            @change="resultCount()"
            :step="0.5"
            name="egr"
            :marks="average_engagement_rate_marks"
            range
            :max="10"
        ></el-slider>
      </el-form-item>
      <div class="side-search-form-title">投稿頻度(週次)</div>
      <el-form-item label>
        <el-slider
            :class="dark_mode ? 'dark' : ''"
            v-model="form_tw.frequency"
            @change="resultCount()"
            :step="1"
            name="frequency"
            :marks="frequency_marks"
            range
            :max="50"
        ></el-slider>
      </el-form-item>
      <!-- PR率 -->
      <div class="side-search-form-title">PR率</div>
      <el-form-item label class="slider">
        <el-slider
            class="sidemenu-load"
            :class="dark_mode ? 'dark' : ''"
            v-model="form_tw.pr_rate"
            @change="resultCount()"
            :step="1"
            name="pr_rate"
            :marks="pr_rate_marks"
            range
            :min="0"
            :max="100"
        ></el-slider>
      </el-form-item>
      <div class="side-search-form-title">
        関連カテゴリ
        <el-tooltip placement="top" content="ポストやプロフィール文章から関連カテゴリを算出します。">
          <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px"/>
        </el-tooltip>
      </div>
      <el-form-item>
        <el-cascader
            v-model="form_tw.category"
            :options="categoryCascaderOptions"
            :show-all-levels="false"
            :props="{ multiple: true }"
            placeholder="関連カテゴリ"
            collapse-tags
            clearable
            filterable
            @change="handleCategoryChange"
            :class="dark_mode ? 'dark' : ''"
            size="mini"
        ></el-cascader>
      </el-form-item>
      <!-- <div class="side-search-form-title">視聴率</div>
      <el-form-item label class="slider" style="margin-bottom:10px">
        <el-slider
          class="sidemenu-load"
          :class="dark_mode ? 'dark' : ''"
          v-model="form_tw.playRate"
          @change="resultCount()"
          :step="10"
          name="viewRate"
          :marks="viewRate_marks"
          range
          :max="100"
        ></el-slider>
      </el-form-item> -->
      <!-- <div class="side-search-form-title">フォロワー女性比率</div>
      <el-form-item label class="slider">
        <el-slider
          class="sidemenu-load"
          :class="dark_mode ? 'dark' : ''"
          v-model="form_tw.female_ratio"
          @change="resultCount()"
          :step="5"
          name="gender"
          :marks="female_ratio_marks"
          range
          :max="100"
        ></el-slider>
      </el-form-item> -->
      <div class="side-search-form-title">
        <span class="pointer" @click="showDetailOption()"
        >詳細オプション
          <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left: 5px;"/>
        </span>
      </div>
      <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'" style="margin-bottom:10px"
           v-show="detail_option">
        <div class="side-search-form-title" style="color: #aaa; margin-top:5px">リストに含まれるインフルエンサーを除外
        </div>
        <el-form-item>
          <el-cascader
              v-model="form_tw.exclude_list"
              :options="sidemenu_option.mylist_twitter"
              :show-all-levels="false"
              :props="{ multiple: true }"
              placeholder="除外するリストを選択"
              collapse-tags
              clearable
              filterable
              @change="resultCount()"
              :class="dark_mode ? 'dark' : ''"
              size="small"
          ></el-cascader>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa;">認証バッジの有無</div>
        <el-form-item>
          <el-select
              clearable
              :class="dark_mode ? 'dark' : ''"
              class="sidemenu-input"
              v-model="form_tw.exclude_badge"
              @change="resultCount()"
              style="margin-left: 0px;"
              placeholder="認証バッジの有無"
              size="small"
          >
            <el-option label="認証バッジ付きのみを表示" value="only"></el-option>
            <el-option label="認証バッジ付きを除外して表示" value="exclude"></el-option>
          </el-select>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa;">お気に入りの有無</div>
        <el-form-item>
          <el-select clearable :class="dark_mode ? 'dark' : ''" v-model="form_tw.exclude_favorite"
                     @change="resultCount()" style="margin-left: 0px;" placeholder="お気に入りの有無" size="small">
            <el-option label="お気に入りのみを表示" value="only"></el-option>
            <el-option label="お気に入りを除外して表示" value="exclude"></el-option>
          </el-select>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa;">カスタマイズタグ</div>
        <div class="side-search-form-radio">
          <el-radio-group v-model="form_tw.tags_search_type" size="mini" @change="resultCount()">
            <el-radio :class="dark_mode ? 'dark' : ''" :label="1">AND検索</el-radio>
            <el-radio :class="dark_mode ? 'dark' : ''" :label="2">OR検索</el-radio>
          </el-radio-group>
        </div>
        <el-form-item>
          <el-cascader
              v-model="form_tw.tags"
              :options="sidemenu_option.tag_list"
              :show-all-levels="false"
              :props="{ multiple: true }"
              placeholder="カスタマイズタグを選択"
              collapse-tags
              clearable
              filterable
              @change="resultCount()"
              :class="dark_mode ? 'dark' : ''"
              size="mini"
          ></el-cascader>
        </el-form-item>
        <div class="side-search-form-title" style="color: #aaa;">Webリンク</div>
        <el-form-item class="bottom">
          <el-input
              v-model="form_tw.weblink"
              class="side-search-form-input"
              :class="dark_mode ? 'dark' : ''"
              placeholder="Webリンクに含まれるキーワード"
              size="mini"
              clearable
              @input="resultCount()"
          ></el-input>
        </el-form-item>
      </div>
    </div>

    <div class="side-search-form-button" :class="dark_mode ? 'dark' : ''">
      <el-button size="small" @click="resetParams()" style="margin-right:10px;" :type="dark_mode ? 'info' : 'default'"
                 :class="dark_mode ? 'dark' : ''">リセット
      </el-button>
      <div style="display:flex; flex:1">
        <el-button native-type="submit" type="primary" class="sidemenu-load" :class="dark_mode ? 'dark' : ''"
                   @click="search()" style="width:100%" size="small">
          検索
        </el-button>
      </div>
    </div>
  </el-form>
</template>

<script>
const root = process.env.VUE_APP_API;
const resultCountAPI = root + "/api/search/result_count_twitter";
import sidemenuSuggestInfluencer from "./sidemenu_suggest_influencer";
import sidemenuSuggestKeyword from "./sidemenu_suggest_keyword";
import { runCampaignGate } from '@/utils/campaignGate';

export default {
  name: "sidemenuTwitter",
  components: {
    sidemenuSuggestInfluencer,
    sidemenuSuggestKeyword,
  },
  data() {
    return {
      follower_marks: {
        500000: "500K+",
      },
      heart_marks: {
        5000000: "5M+",
      },
      female_ratio_marks: {
        100: "100%",
      },
      average_engagement_rate_marks: {
        10: "10%+",
      },
      viewRate_marks: {
        100: "100%+",
      },
      frequency_marks: {
        50: "50+",
      },
      pr_rate_marks: {
        100: "100%",
      },
      mylist_tiktok: [],
      actionId: +new Date(),
      requestId: +new Date(),
      next_cursor: "",
      language: "jp",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    dark_mode() {
      return this.$store.state.dark_mode;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    activate() {
      return this.$store.state.activate;
    },
    form_tw() {
      return this.$store.state.form_tw;
    },
    form_tw_initial() {
      return this.$store.state.form_tw_initial;
    },
    tw_search() {
      return this.$store.state.tw_search;
    },
    sidemenu_option() {
      return this.$store.state.sidemenu_option;
    },
    detail_option() {
      return this.$store.state.detail_option;
    },
    categoryCascaderOptions() {
      return this.categoryOption(this.sidemenu_option.category_list);
    }
  },
  mounted() {
  },
  created() {
    if (!Array.isArray(this.form_tw.pr_rate) || this.form_tw.pr_rate.length !== 2) {
      this.$set(this.form_tw, 'pr_rate', [0, 100]);
    }
  },
  methods: {
    resultCount() {
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("user_token", this.user_token);
      const form_tw = Object.assign({}, this.form_tw);
      form_tw.has_recent_post_1month = !!this.$store.state.recent_post_1month;
      params.append("params", JSON.stringify(form_tw));
      this.axios
          .post(resultCountAPI, params, {requestId: this.requestId})
          .then(() => {
            this.$store.dispatch("form_tw", form_tw);
          })
          .catch(() => {});
    },
    async search() {
      var form_tw = Object.assign({}, this.form_tw);
      form_tw.has_recent_post_1month = !!this.$store.state.recent_post_1month;

      // 記号は「._()@#&･」及び全角のみ許可
      var reg = new RegExp(/[!"$%'*+,/:;<=>?@[\\\]^`{|}~]/g);
      // ローマ字1文字（大文字・小文字）だけの入力をNG
      var singleAlphaReg = new RegExp(/^[A-Za-z]$/);
      if (reg.test(form_tw.account_name) || 
          reg.test(form_tw.keyword) ||
          reg.test(form_tw.exclude_keyword) ||
          singleAlphaReg.test(form_tw.account_name) ||
          singleAlphaReg.test(form_tw.keyword) ||
          singleAlphaReg.test(form_tw.exclude_keyword)
      ) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "検索キーワードが短すぎる、もしくは使用できない記号が含まれています",
        });
        return;
      }

      // キャンペーンモーダルを表示（閉じたら続行）
      try {
        await runCampaignGate('intro_slide_announce');
      } catch (e) {/* no-op: モーダル取得に失敗しても検索は続行 */}

      this.$store.dispatch("tw_search", form_tw);
      this.$router.push({
        name: "twitterer",
        query: {actionId: (this.actionId += 1)},
        params: {sns_type: "twitter"},
      });
    },
    nameSearch() {
      const account_name = this.form_tw.account_name;
      var form_tw = Object.assign({}, this.form_tw_initial);
      form_tw.account_name = account_name;
      this.$store.dispatch("form_tw", form_tw);
      this.resultCount();
      this.search();
    },
    resetParams() {
      this.$store.dispatch("recent_post_1month", false);
      this.$store.dispatch("form_tw", Object.assign({}, this.form_tw_initial)).then(() => {
        this.resultCount();
      });
    },
    resetKeyword() {
      this.form_tw.account_name = "";
      this.form_tw.keyword = "";
      this.form_tw.exclude_keyword = "";
      this.resultCount();
    },
    showDetailOption() {
      this.$store.dispatch("showDetailOption");
    },
    categoryOption(category) {
      if (!category || !Array.isArray(category) || category.length === 0) {
        return [{
          value: "all",
          label: "全て選択",
          children: []
        }];
      }
      const options = category.map(item => ({
        label: item.label,
        value: item.value
      }));
      return [{
        value: "all",
        label: "全て選択",
        children: options
      }];
    },
    validateCategory(value) {
      if (!Array.isArray(value)) {
        return []; // 空配列に初期化
      }
      return value;
    },
    handleCategoryChange(value) {
      let category = this.validateCategory(value);
      this.$set(this.form_tw, 'category', category);
      this.$set(this.form_tw, 'sort_key', 'follower_count');
      this.resultCount();
    }
  },
};
</script>
